export var mutations = {
    setCompany: function (state, company) { return state.company = company; },
    setCompanyTags: function (state, tags) { return state.tags = tags; },
    setLoading: function (state, loading) { return state.loading = loading; },
    setLoadingTags: function (state, loading) { return state.loadingTags = loading; },
    setUsers: function (state, users) { return state.users = users; },
};
